<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <cal-picker
                      v-model="form.asAtDate"
                      :label="labels.asAtDate"
                      :data-vv-as="labels.asAtDate"
                      data-vv-name="form.asAtDate"
                      :error-messages="errors.collect('form.asAtDate')"
                      v-validate="'required'"
                      :max="this.today"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.branch"
                      :label="labels.branch"
                      :error-messages="errors.collect('form.branch')"
                      :data-vv-as="labels.branch"
                      v-validate="'required'"
                      data-vv-name="form.branch"
                      append-icon="mdi-magnify"
                      @click:append="showBranchHelpList = true"
                      @click="showBranchHelpList = true"
                      readonly
                    />
                  </v-flex>
                  <v-flex xs12>
                        <v-text-field
                          v-model="form.dept"
                          :label="labels.dept"
                          :error-messages="errors.collect('form.dept')"
                          data-vv-name="form.dept"
                          :data-vv-as="labels.dept"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="showDeptHelpList = true"
                          @click="showDeptHelpList = true"
                        ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div>RI Type (Select at least ONE RI Type)</div>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      :label="labels.riC"
                      v-model="form.riC"
                      :error-messages="errors.collect('form.riC')"
                      data-vv-name="form.riC"
                      :data-vv-as="labels.riC"
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      :label="labels.riD"
                      v-model="form.riD"
                      :error-messages="errors.collect('form.riD')"
                      data-vv-name="form.riD"
                      :data-vv-as="labels.riD"
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      :label="labels.riF"
                      v-model="form.riF"
                      :error-messages="errors.collect('form.riF')"
                      data-vv-name="form.riF"
                      :data-vv-as="labels.riF"
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      :label="labels.riT"
                      v-model="form.riT"
                      :error-messages="errors.collect('form.riT')"
                      data-vv-name="form.riT"
                      :data-vv-as="labels.riT"
                    />
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      :label="labels.riW"
                      v-model="form.riW"
                      :error-messages="errors.collect('form.riW')"
                      data-vv-name="form.riW"
                      :data-vv-as="labels.riW"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <div>RI Company (enter at least one RI Company or RI Company begins with, e.g. R00002*)</div>
                    <table border="1">
                      <tr>
                        <td><input type="text" v-model="form.riCo1" maxlength="8" class="long-input" /></td>
                        <td><input type="text" v-model="form.riCo2" maxlength="8" class="long-input"/></td>
                        <td><input type="text" v-model="form.riCo3" maxlength="8" class="long-input"/></td>
                        <td><input type="text" v-model="form.riCo4" maxlength="8" class="long-input"/></td>
                        <td><input type="text" v-model="form.riCo5" maxlength="8" class="long-input"/></td>
                        <td><input type="text" v-model="form.riCo6" maxlength="8" class="long-input"/></td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Sort Order</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      :label="labels.sort"
                      v-model="form.sort"
                      :error-messages="errors.collect('form.sort')"
                      data-vv-name="form.sort"
                      :data-vv-as="labels.sort"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="form.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showDeptHelpList" width="900px" persistent>
          <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [MessageMixin],
  components: {
    MultiBranchHelpList,
    MultiDeptHelpList
  },
  data() {
    return {
      menu: {},
      showBranchHelpList: false,
      showDeptHelpList: false,
      showErrorDialog: false,
      submitting: false,
      form: {
        asAtDate: new Date(),
        branch: 'All',
        dept: 'All',
        pbPrtParam: true,
        format: 'PDF',
        sort: false,
        riC: false,
        riD: false,
        riF: false,
        riT: false,
        riW: false,
        riCo1: '',
        riCo2: '',
        riCo3: '',
        riCo4: '',
        riCo5: '',
        riCo6: ''
      },
      labels: {
        asAtDate: 'Reinsurance O/S Claims As At',
        branch: 'Branch',
        dept: 'Department',
        sortOrder: 'Sort Order',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO',
        sort: 'Sort by Branch / Department / Business Source / Country /Treaty Type',
        riC: 'CoInsurance',
        riD: 'Statutory',
        riF: 'Facultative',
        riT: 'Treaty',
        riW: 'Quota Share'
      },
      columns: [
        { label: 'Branch', value: 'branch' },
        { label: 'Business Source', value: 'busSrc' },
        { label: 'Class', value: 'busCls' },
        { label: 'Class Group', value: 'busClsGrp' },
        { label: 'Direct/RI', value: 'dri' },
        { label: 'Executive', value: 'exec' },
        { label: 'Fund', value: 'fund' },
        { label: 'Policy Type', value: 'polType' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      supportedFormat: [],
      panel1: [0],
      panel2: [],
      panel3: [],
      panel4: [0],
      today: new Date()
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      // result.push(reportFormat.PDF)
      result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.osClmRIBord
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.showErrorDialog = true
            this.fieldMessage(data)
            this.submitting = false
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showDeptHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(obj) {
      this.form.dept = []
      this.form.dept = obj.finalSelectedItems.toString()
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
.long-input {
  width: 150px;
  height: 40px;
}
</style>
